import { IconCheckCircle, IconError, Button } from 'cdk-radial';
import styled from 'styled-components';

export const PaymentResultGridStyle = styled.div`
  padding: 30px 0px;
`;

export const PaymentDetailTableHeaderStyle = styled.div`
  padding-top: 0px;
`;
export const IconErrorStyle = styled(IconError)`
  fill: red;
`;

export const IconCheckCircleStyle = styled(IconCheckCircle)`
  fill: green;
`;

export const RetryButtonStyle = styled(Button)`
  position: relative;
  top: -5px;
  margin-right: 10px;
  margin-top: 5px;
`;

export const FailedGridOptionsStyle = styled.div`
  float: right;
  display: flex;
`;

export const PaymentDetailTableHeaderContentStyle = styled.div`
  fontfamily: Roboto, sans-serif;
  font-size: 1.125rem;
  font-weight: 500;
  display: inline-block;
  padding-left: 5px;
  position: relative;
  top: -5px;
`;

export const PaymentDetailFailedTableSubText = styled.h3`
  font-weight: 400;
`;
export const SubTextStyle = styled.div`
  padding-left: 10px;
  color: gray;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
